/* Decottaa teması – koleksiyon kutularında görsellerin sırayla yumuşak geçişle değişmesi (ana sayfa). */
(() => {
  class TileRotator extends HTMLElement {
    connectedCallback() {
      this.images = Array.from(this.querySelectorAll('img'));
      if (this.images.length < 2) return;
      this.index = 0;
      this.interval = Number(this.dataset.interval) || 3500;
      this.delay = Number(this.dataset.delay) || 0;
      // Yalnız ekranda görünürken döner
      this.observer = new IntersectionObserver((entries) => (entries[0].isIntersecting ? this.start() : this.stop()));
      this.observer.observe(this);
    }

    disconnectedCallback() {
      this.stop();
      if (this.observer) this.observer.disconnect();
    }

    start() {
      if (this.timer || this.wait) return;
      this.wait = setTimeout(() => {
        this.wait = null;
        this.timer = setInterval(() => this.next(), this.interval);
      }, this.delay);
    }

    stop() {
      clearTimeout(this.wait);
      clearInterval(this.timer);
      this.wait = null;
      this.timer = null;
    }

    next() {
      this.images[this.index].classList.remove('is-active');
      this.index = (this.index + 1) % this.images.length;
      this.images[this.index].classList.add('is-active');
    }
  }
  if (!customElements.get('tile-rotator')) customElements.define('tile-rotator', TileRotator);
})();
